import { API_PATHS } from "../constants/api-paths";
import { logErrorToNewRelic } from "../utils/logging";
import { IResponse, request } from "../core/api.client";

export interface IGetPincodeResponse {
  id: number;
  cityName: string;
  stateName: string;
  stateCode: string;
  sourcingBranchCategory: string;
}

export const getProductByPincode = async (
  value: string
): Promise<IResponse<IGetPincodeResponse>> => {
  try {
    const response = await request<IGetPincodeResponse>({
      method: "POST",
      url: API_PATHS.getProductByPincode,
      data: {
        pinCode: +value,
      },
    });
    return response;
  } catch (error) {
    logErrorToNewRelic(error as Error);
    return {} as IResponse<IGetPincodeResponse>;
  }
};
